import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux'; 
import _ from 'underscore';
import styles from './index.module.scss';
import { initUrlParams, stringifySearch } from '../../../../../utils';


function NoticeFilterMsg() {

  const history = useHistory();
  const { pathname } = useLocation();
  const {
    urlParams,
  } = useSelector(state => state.searchReducer);

  const handleSearchMore = () => {
    const _searchParamsBody = JSON.parse(JSON.stringify(urlParams));
    // initUrlParams(_searchParamsBody, true)
    _searchParamsBody.showMore = 1
   
    history.push({
      pathname,
      search: stringifySearch(_searchParamsBody)
    })
  }

  return (
    <div className={styles["notice-filter-msg"]}>
      为方便您找到满意的商品，我们已为您省略部分不相关的商品，
      <span onClick={handleSearchMore}>查看更多商品&nbsp;&gt;</span>
    </div>
  )
}

export default NoticeFilterMsg;